import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=a5c25aaa&scoped=true&"
import script from "./ImageView.vue?vue&type=script&lang=ts&"
export * from "./ImageView.vue?vue&type=script&lang=ts&"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=a5c25aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c25aaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VContainer,VFlex,VImg,VLayout,VSkeletonLoader})
